// extracted by mini-css-extract-plugin
export default {"Container":"tournamentsCard_Container__VuoHn","CardList":"tournamentsCard_CardList__0Fnya"};